import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatSession } from '../../models/chat-session.model';

@Component({
  selector: 'app-chat-history',
  templateUrl: './chat-history.component.html',
  styleUrls: ['./chat-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatHistoryComponent {
  @Input() sessions: ChatSession[] = [];
  @Input() activeSessionId: string | null = null;

  @Output() createNew = new EventEmitter<void>();
  @Output() sessionSelected = new EventEmitter<string>();
  @Output() deleteSession = new EventEmitter<string>();

  actionsOpen: string | null = null;

  trackBySessionId(index: number, session: ChatSession) {
    return session.id || index;
  }

  titlePreview(title: string) {
    if (!title) {
      return 'New chat';
    }
    const words = title.trim().split(/\s+/);
    const preview = words.slice(0, 10).join(' ');
    const ellipsis = words.length > 10 || title.trim().length > preview.length ? '...' : '';
    const capped = preview.length > 48 ? `${preview.slice(0, 45).trim()}...` : preview;
    return `${capped}${ellipsis}`;
  }

  onDelete(sessionId: string, event: MouseEvent) {
    event.stopPropagation();
    this.deleteSession.emit(sessionId);
  }
}
